<template>
    <el-container style="height: 100vh">
        <router-view />
    </el-container>
</template>
<script>
export default {name: 'GuestLayout'};
</script>
<style scoped></style>
